"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.touchevents = touchevents;

var _isServer = _interopRequireDefault(require("./isServer"));

function touchevents() {
  if ((0, _isServer.default)()) {
    return false;
  }

  return 'ontouchstart' in window;
}